import { Link } from 'react-router-dom';
import { ROUTES } from 'Constants';
import { OverbookingWarningDto } from './OverbookingWarningDto';
import { OverbookingInsightDetails } from './OverbookingInsightDetails';
import { store } from 'Models/Store';

interface OverbookingWarningListProps {
	overbookingWarnings: OverbookingWarningDto[];
}

export function OverbookingWarningList({ overbookingWarnings }: OverbookingWarningListProps) {
	if (overbookingWarnings.length < 1) {
		return <></>;
	}

	const { tripId } = overbookingWarnings[0];

	return (
		<div className="w-full">
			{store.isStaff && (
				<div className="mb-2 text-sm font-semibold text-gray-700">
					<Link target="_blank" to={ROUTES.FERRY_SCHEDULE_EDIT.url(tripId, 'insights')} className="text-xs">
						View occupancy details
					</Link>
				</div>
			)}
			{overbookingWarnings.map(warning => (
				<div
					key={`${warning.overbookingCause}-${warning.capacityType}`}
					className="p-3 mb-3 border border-gray-200 rounded bg-gray-50 last:mb-0"
				>
					<OverbookingInsightDetails overbookingWarning={warning} />
				</div>
			))}
		</div>
	);
}
